<!-- Template from page -->
<template>
  <section>
    <leftMenu />

    <button-back :btnRoute="'/'"/>
    <success-register-point :changeRoute.sync="route"/>

    <div id="mainContent" class="point-registration-content">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 pg-title">
          <h1 class="certa">Registro de Ponto</h1>
        </div>

        <div v-if="!loadingSendPoint" class="col-xs-12 col-sm-4 col-md-5 offset-top-30">
          <div class="col-xs-12 col-sm-12 col-md-12 default-box box-register-point">
            <div v-if="!dataInfo.needPhotoToRegisterInWeb && !dataInfo.useWorkingLocalUser" class="empty-content">
              <img src="../../../..../../../assets/img/point/ImagemSemPonto.png" class="img-responsive" alt="Registro">
            </div>
            <div v-if="dataInfo.needPhotoToRegisterInWeb" class="webcam-content">
              <div v-if="haveCam && dataInfo.needPhotoToRegisterInWeb" class="cam">
                <video ref="video" id="video" width="640" height="480" autoplay="true"></video>
                <canvas ref="canvas" id="canvas" width="640" height="480"></canvas>
              </div>
              <p v-if="haveCam && dataInfo.needPhotoToRegisterInWeb" class="nunito">Vamos precisar da sua foto para fazer o registro do ponto.</p>

              <div v-if="!haveCam && dataInfo.needPhotoToRegisterInWeb" class="webcam-empty">
                <img src="../../../..../../../assets/img/empty/cam.png" class="img-responsive" alt="Camera">
                <p class="nunito">Webcam não encontrada, reconecte ou verifique se a permissão do navegador está habilitada corretamente.</p>
              </div>
            </div>
            <div v-if="showFeelingsDay" class="content-answer">
              <h3 class="certa title-text">Como você está se sentindo?</h3>
              <div class="set-feeling">
                <img v-on:click="addFeeling(1)" v-bind:class="{'active': dataSendFeeling.mood === 1}" src="../../../../assets/img/feelings/1.png" class="img-fluid" alt="feeling"/>
                <img v-on:click="addFeeling(2)" v-bind:class="{'active': dataSendFeeling.mood === 2}" src="../../../../assets/img/feelings/2.png" class="img-fluid" alt="feeling"/>
                <img v-on:click="addFeeling(3)" v-bind:class="{'active': dataSendFeeling.mood === 3}" src="../../../../assets/img/feelings/3.png" class="img-fluid" alt="feeling"/>
                <img v-on:click="addFeeling(4)" v-bind:class="{'active': dataSendFeeling.mood === 4}" src="../../../../assets/img/feelings/4.png" class="img-fluid" alt="feeling"/>
                <img v-on:click="addFeeling(5)" v-bind:class="{'active': dataSendFeeling.mood === 5}" src="../../../../assets/img/feelings/5.png" class="img-fluid" alt="feeling"/>
              </div>
            </div>

            <div v-if="dataInfo.useWorkingLocalUser" class="content-answer content-answer-location">
              <h3 class="certa title-text">De onde você está trabalhando hoje?</h3>
              <div class="set-location-point">
                <div class="locations-point locations-point-1" @click="addLocationPoint(2)" :class="{'active': dataSendLocationPoint.local === 2}">
                  <span>
                    <ion-icon name="home-outline"></ion-icon>
                    Casa
                  </span>
                </div>
                <div class="locations-point locations-point-2" @click="addLocationPoint(1)" :class="{'active': dataSendLocationPoint.local === 1}">
                  <span>
                    <ion-icon name="business-outline"></ion-icon>
                    Escritório
                  </span>
                </div>
                <div class="locations-point locations-point-3" @click="addLocationPoint(3)" :class="{'active': dataSendLocationPoint.local === 3}">
                  <span>
                    <ion-icon name="location-outline"></ion-icon>
                    Outro
                  </span>
                </div>
              </div>
            </div>
            <div v-if="needGadgets" class="content-gadgets offset-top-20">
              <p>Selecione em que local você está<span class="required-field">*</span></p>
              <select v-model="selectedGadgets">
                <option value="" selected disabled>Selecione</option>
                <option v-for="v in listGadgets" v-bind:value="v">
                  {{ v.name }}
                </option>
              </select>
            </div>
            <div v-if="needException" class="content-gadgets offset-top-20">
              <p>Motivo do ponto por exceção<span class="required-field">*</span></p>
              <select v-model="selectedException">
                <option value="" selected disabled>Selecione</option>
                <option v-for="v in listException" v-bind:value="v">
                  {{ v.name }}
                </option>
              </select>
            </div>
            <button v-on:click="checkDataToRegisterPoint()" :disabled="loadingRequest" v-bind:class="{'disable': loadingRequest}" class="btn-point">
              <div v-if="loadingRequest" class="loading-btn-login">
                <div class="spinner-btn-yellow">
                  <div class="rect1"></div>
                  <div class="rect2"></div>
                  <div class="rect3"></div>
                  <div class="rect4"></div>
                  <div class="rect5"></div>
                </div>
              </div>
              <span v-else class="certa">
                <i class="fa fa-hand-pointer-o" aria-hidden="true"></i>
                Marcar ponto
              </span>
            </button>
            <p class="required-field field-10">{{dataSendError}}</p>
          </div>
        </div>

        <div v-if="loadingSendPoint" class="col-xs-12 col-sm-4 col-md-5 offset-top-30">
          <div class="col-xs-12 col-sm-12 col-md-12 default-box box-info-hours">
            <div class="new-progress-bar-point">
              <div class="circle">
                <progress-loading :additionalBoxStyle="''" :additionalLineStyle="'top: 0px;border-radius: 100%;height: 300px;width: 300px;margin: 0;left: -50px;'"/>
              </div>
            </div>
            <div style="height: 40px"></div>
            <div class="hours-info">
              <progress-loading :additionalBoxStyle="''" :additionalLineStyle="'margin: 60px auto 0; height: 16px; top: 10px; width: 50%'"/>
              <progress-loading :additionalBoxStyle="''" :additionalLineStyle="'margin: 10px auto 0; height: 26px; top: 10px; width: 60%'"/>
              <progress-loading :additionalBoxStyle="''" :additionalLineStyle="'margin: 10px auto 0; height: 41px; top: 10px; width: 90%'"/>
            </div>
          </div>
        </div>

        <div v-if="!loadingInfo" class="col-xs-12 col-sm-4 col-md-4 offset-top-30">
          <div class="col-xs-12 col-sm-12 col-md-12 default-box box-info-hours">
            <div v-if="dataInfo.lastPoint" class="last-point">
              <p class="nunito">Último ponto</p>
              <p class="certa">{{dataInfo.lastPoint}}</p>
            </div>

            <div v-else class="empty-point">
              <p class="certa">Nenhum ponto<br>marcado hoje.</p>
            </div>

            <div class="hours-info">
              <p class="nunito">Hora agora</p>
              <p class="certa">{{currentTime}}</p>
            </div>

            <div class="new-progress-bar-point">
              <div class="circle">
                <div id="maskFull" class="mask full">
                  <div id="firstFill" class="fill background-bue"></div>
                </div>
                <div class="mask half">
                  <div id="secondFill" class="fill background-bue"></div>
                </div>
                <div class="inside-circle">
                  <p>
                    <span class="nunito">Horas trabalhadas</span>
                    <span class="certa title-text">{{dataWork.dayHours}}<span class="nunito"></span></span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="loadingInfo" class="col-xs-12 col-sm-4 col-md-4 offset-top-30">
          <div class="col-xs-12 col-sm-12 col-md-12 default-box box-info-hours">
            <div class="last-point">
              <progress-loading :additionalBoxStyle="''" :additionalLineStyle="'margin: 0 auto; height: 16px; top: 10px; width: 56%'"/>
              <progress-loading :additionalBoxStyle="''" :additionalLineStyle="'margin: 10px auto 0; height: 16px; top: 10px; width: 76%'"/>
            </div>

            <div class="hours-info">
              <progress-loading :additionalBoxStyle="''" :additionalLineStyle="'margin: 0 auto; height: 16px; top: 10px; width: 50%'"/>
              <progress-loading :additionalBoxStyle="''" :additionalLineStyle="'margin: 10px auto 0; height: 16px; top: 10px; width: 50%'"/>
            </div>

            <div class="new-progress-bar-point">
              <div class="circle">
                <progress-loading :additionalBoxStyle="''" :additionalLineStyle="'top: 0; border-radius: 100%; height: 200px; width: 200px;'"/>
              </div>
            </div>
          </div>
        </div>

        <div v-if="!loadingInfo && dataInfo.text" class="col-xs-12 col-sm-4 col-md-3 offset-top-30">
          <div class="col-xs-12 col-sm-12 col-md-12 default-box box-info">
            <img v-if="isDark" src="../../../..../../../assets/img/point/virada-turno-dark.png" class="img-responsive" alt="Virada de Turno" />
            <img v-if="!isDark" src="../../../..../../../assets/img/point/ImagemViradaTurno.png" class="img-responsive" alt="Virada de Turno" />
            <p class="certa">Virada de turno</p>
            <p class="nunito">{{dataInfo.text}}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Block page -->
    <div v-if="showBlockPage" class="block-page">
      <div class="bg-color"></div>
      <div class="info-block">
        <h4>Parece que você ficou ausente</h4>
        <p>Você não interagiu com essa página por mais de 2 minutos. Clique no botão abaixo para atualizar a página e marcar seu ponto.</p>
        <button v-on:click="refreshPage()">
          <ion-icon name="refresh-outline"></ion-icon>
          <span>Atualizar página</span>
        </button>
      </div>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="myModal" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h4 class="modal-title certa title-color">Não é possível marcar o ponto</h4>
          </div>

          <div class="modal-body">
            <div class="info">
              <p class="nunito text-color">Seu navegador está bloqueando a localização. Você precisa liberar para poder registrar o ponto normalmente. Veja como fazer nos navegadores abaixo:</p>

              <ul class="list-browser">
                <li>
                  <img src="../../../../assets/img/point/chrome.png" alt="chrome" class="img-responsive"/>
                  <a class="link" href="https://support.google.com/chrome/answer/142065?co=GENIE.Platform%3DDesktop&hl=pt" target="_blank">Google Chrome</a>
                </li>
                <li>
                  <img src="../../../../assets/img/point/edge.png" alt="chrome" class="img-responsive"/>
                  <a class="link" target="_blank" href="https://support.microsoft.com/pt-br/help/4536154/microsoft-edge-location-and-privacy">Microsoft Edge</a>
                </li>
                <li>
                  <img src="../../../../assets/img/point/firefox.png" alt="chrome" class="img-responsive"/>
                  <a class="link" target="_blank" href="https://support.mozilla.org/pt-BR/kb/o-firefox-compartilha-minha-localizacao-com-sites#:~:text=%C3%89%20poss%C3%ADvel%20configurar%20o%20Firefox,todos%20os%20sites%2C%20sem%20perguntar.&text=Clique%20no%20menu-,e%20selecione%20Op%C3%A7%C3%B5es.,des%C3%A7a%20at%C3%A9%20a%20se%C3%A7%C3%A3o%20Permiss%C3%B5es).">Mozilla Firefox</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="close-btn" data-dismiss="modal">Fechar</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="modalDontSupport" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h5 class="certa first-title"><span>Aviso</span></h5>
          </div>

          <div class="modal-body">
            <div class="info">
              <p class="nunito text-color">
                Olá! A sua localização é necessária para o registro de ponto, mas o seu navegador não tem suporte para isso. <br>
                Por favor, faça uma atualização do seu navegador para o sistema funcionar corretamente.
              </p>
            </div>
          </div>

          <div class="modal-footer offset-top-20">
            <button type="button" class="nunito close-btn" data-dismiss="modal">Fechar</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="modalWorkShift" role="dialog">
      <div class="modal-dialog modal-dialog-35" v-bind:style="{'width': width}">
        <!-- Modal content-->
        <div class="modal-content modal-workshift">
          <div class="modal-header">
            <button type="button" class="close" @click="closeModal()" data-dismiss="modal">&times;</button>
            <span>Selecione qual ponto você deseja marcar:</span>
          </div>
          <div class="modal-body">
            <div class="body-content">
              <div @click="setTurnSelected(1)" class="content-btn point-entrance" :style="turnSelected === 1 ? 'background: #2ACC6B;' : ''">
                <span v-if="dataInfo.lastPointRegisterType === 1" class="last-point">Último ponto</span>
                <div :style="turnSelected === 1 ? 'color: #FFFFFF;' : ''" class="btn-text">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path :style="turnSelected === 1 ? 'fill: #FFFFFF;' : ''" d="M10.09 15.59L11.5 17L16.5 12L11.5 7L10.09 8.41L12.67 11H3V13H12.67L10.09 15.59ZM19 3H5C4.46957 3 3.96086 3.21071 3.58579 3.58579C3.21071 3.96086 3 4.46957 3 5V9H5V5H19V19H5V15H3V19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3Z" fill="#2ACC6B"/>
                  </svg>
                  Entrada
                </div>
                <span :style="turnSelected === 1 ? 'color: #FFFFFF;' : ''" v-if="dataInfo.lastPointRegisterType === 1" class="last-appointment">
                  <span class="last-day">{{dataInfo.lastPointDate }}</span>
                  <span class="last-hour">{{dataInfo.lastPointHour }}</span>
                </span>
              </div>
              <div @click="setTurnSelected(2)" class="content-btn point-exit-interval" :style="turnSelected === 2 ? 'background: #FF9900;' : ''">
                <span v-if="dataInfo.lastPointRegisterType === 2" class="last-point">Último ponto</span>
                <div :style="turnSelected === 2 ? 'color: #FFFFFF;' : ''" class="btn-text">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path :style="turnSelected === 2 ? 'fill: #FFFFFF;' : ''" d="M9.25 16.25H11.25V8.25H9.25V16.25ZM12.25 2.25C6.73 2.25 2.25 6.73 2.25 12.25C2.25 17.77 6.73 22.25 12.25 22.25C17.77 22.25 22.25 17.77 22.25 12.25C22.25 6.73 17.77 2.25 12.25 2.25ZM12.25 20.25C7.84 20.25 4.25 16.66 4.25 12.25C4.25 7.84 7.84 4.25 12.25 4.25C16.66 4.25 20.25 7.84 20.25 12.25C20.25 16.66 16.66 20.25 12.25 20.25ZM13.25 16.25H15.25V8.25H13.25V16.25Z" fill="#FF9900"/>
                  </svg>
                  Saída intervalo
                </div>
                <span :style="turnSelected === 2 ? 'color: #FFFFFF;' : ''" v-if="dataInfo.lastPointRegisterType === 2" class="last-appointment">
                  <span class="last-day">{{dataInfo.lastPointDate }}</span>
                  <span class="last-hour">{{dataInfo.lastPointHour }}</span>
                </span>
              </div>
              <div @click="setTurnSelected(3)" class="content-btn btn-back-interval" :style="turnSelected === 3 ? 'background: #2F23D6;' : ''">
                <span v-if="dataInfo.lastPointRegisterType === 3" class="last-point">Último ponto</span>
                <div :style="turnSelected === 3 ? 'color: #FFFFFF;' : ''" class="btn-text">
                  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path :style="turnSelected === 3 ? 'fill: #FFFFFF;' : ''" d="M10.5 16.5L16.5 12L10.5 7.5V16.5ZM12.5 2C6.98 2 2.5 6.48 2.5 12C2.5 17.52 6.98 22 12.5 22C18.02 22 22.5 17.52 22.5 12C22.5 6.48 18.02 2 12.5 2ZM12.5 20C8.09 20 4.5 16.41 4.5 12C4.5 7.59 8.09 4 12.5 4C16.91 4 20.5 7.59 20.5 12C20.5 16.41 16.91 20 12.5 20Z" fill="#2F23D6"/>
                  </svg>
                  Volta intervalo
                </div>
                <span :style="turnSelected === 3 ? 'color: #FFFFFF;' : ''" v-if="dataInfo.lastPointRegisterType === 3" class="last-appointment">
                  <span class="last-day">{{dataInfo.lastPointDate }}</span>
                  <span class="last-hour">{{dataInfo.lastPointHour }}</span>
                </span>
              </div>
              <div @click="setTurnSelected(4)" class="content-btn point-exit" :style="turnSelected === 4 ? 'background: #FF445D;' : ''">
                <span v-if="dataInfo.lastPointRegisterType === 4" class="last-point">Último ponto</span>
                <div :style="turnSelected === 4 ? 'color: #FFFFFF;' : ''" class="btn-text">
                  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path :style="turnSelected === 4 ? 'fill: #FFFFFF;' : ''" d="M14.41 8.41L13 7L8 12L13 17L14.41 15.59L11.83 13L21.5 13L21.5 11L11.83 11L14.41 8.41ZM5.5 21L19.5 21C20.0304 21 20.5391 20.7893 20.9142 20.4142C21.2893 20.0391 21.5 19.5304 21.5 19L21.5 15L19.5 15L19.5 19L5.5 19L5.5 5L19.5 5L19.5 9L21.5 9L21.5 5C21.5 4.46957 21.2893 3.96086 20.9142 3.58579C20.5391 3.21071 20.0304 3 19.5 3L5.5 3C4.4 3 3.5 3.9 3.5 5L3.5 19C3.5 20.1 4.4 21 5.5 21Z" fill="#FF445D"/>
                  </svg>
                  Saída
                </div>
                <span :style="turnSelected === 4 ? 'color: #FFFFFF;' : ''" v-if="dataInfo.lastPointRegisterType === 4" class="last-appointment">
                  <span class="last-day">{{dataInfo.lastPointDate }}</span>
                  <span class="last-hour">{{dataInfo.lastPointHour }}</span>
                </span>
              </div>
            </div>
            <div class="footer-content">
              <div v-if="dataInfo.lastPointRegisterType === turnSelected && dataInfo.lastPointRegisterType === 1" class="point-repeat">Seu último ponto foi uma entrada, tem certeza que deseja marcar novamente?</div>
              <div v-if="dataInfo.lastPointRegisterType === turnSelected && dataInfo.lastPointRegisterType === 2" class="point-repeat">Seu último ponto foi uma saída intevalo, tem certeza que deseja marcar novamente?</div>
              <div v-if="dataInfo.lastPointRegisterType === turnSelected && dataInfo.lastPointRegisterType === 3" class="point-repeat">Seu último ponto foi uma volta intervalo, tem certeza que deseja marcar novamente?</div>
              <div v-if="dataInfo.lastPointRegisterType === turnSelected && dataInfo.lastPointRegisterType === 4" class="point-repeat">Seu último ponto foi uma saída, tem certeza que deseja marcar novamente?</div>
              <div class="content-btn">
                <span @click="closeModal()" class="btn-cancel">Cancelar</span>
                <button v-on:click="confirmPoint()" class="btn-confirm" :disabled="turnSelected === 0 || turnSelected === ''">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11.4583 8.49171L11.9833 8.60004L15.4583 10.3334C16.0417 10.525 16.425 11.1 16.375 11.7167V11.9334L15.625 17.0334C15.575 17.3917 15.4167 17.725 15.125 17.9584C14.8667 18.2084 14.525 18.3334 14.1667 18.3334H8.43333C8.025 18.3334 7.65 18.1834 7.375 17.8917L2.38333 12.9167L3.13333 12.0834C3.33333 11.875 3.65 11.7584 3.95 11.775H4.19166L7.5 12.5V3.75004C7.5 3.30801 7.67559 2.88409 7.98815 2.57153C8.30071 2.25897 8.72464 2.08337 9.16666 2.08337C9.60869 2.08337 10.0326 2.25897 10.3452 2.57153C10.6577 2.88409 10.8333 3.30801 10.8333 3.75004V8.49171H11.4583Z" fill="white"/>
                  </svg>
                  Confirmar ponto
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <vue-footer/>
  </section>
</template>

<!-- Script from page -->
<script>
import leftMenu from '../../components/leftMenu.vue'
import buttonBack from "../../components/buttonBack";
import loadingPage from "../../components/loadingPage";
import successRegisterPoint from "../../modals/successRegisterPoint.vue";
import progressLoading from "../../components/progressLoading";

import vueFooter from '../../components/footer.vue'
import moment from 'moment'
import swal from 'sweetalert';

import {
  IS_DEBUG, NEW_REGISTER_POINT,
  POINT_DAY_DETAIL,
  REGISTER_POINT_CORE,
  SEND_BUG,
  SEND_USER_FEELING,
  TIMER, WORKING_LOCAL_EMPLOYEE, WORKING_LOCAL_EMPLOYEE_TODAY, GET_EXCEPTION
} from "../../../../urlConfig";
import { REQUEST_SERVICE } from "../../../../requestConfig";
import { UTIL_SERVICE } from "../../../../utils";

export default {
  name: 'point',
  components: {
    buttonBack,
    progressLoading,
    leftMenu,
    loadingPage,
    successRegisterPoint,
    vueFooter
  },
  data() {
    return {
      turnSelected: '',
      width: '100%',
      timerBlockPage: 1,
      showBlockPage: false,
      needGadgets: false,
      needException: false,
      listGadgets: [],
      listException: [],
      selectedGadgets: '',
      selectedException: '',
      dataSendError: '',
      dataSendFeeling: {
        mood: '',
        comment: '',
        eDeviceType: 3
      },
      dataSendLocationPoint: {
        local: '',
      },
      showFeelingsDay: false,
      historyListPoints: null,
      dataAuthInfo: {},
      geoC: {
        latitude: '',
        longitude: '',
        elevation: ''
      },
      dataUserInfo: {},
      homeCtrl: null,
      dateLastPoint: null,
      isDark: null,
      showPause: false,
      loadingInfo: false,
      loadingSendPoint: false,
      loadingRequest: false,
      haveCam: true,
      currentTime: "",
      currentDateTime: "",
      captures: "",
      stream: "",
      dataWebCam: "",
      video: {},
      canvas: {},
      dataRegister: {},
      dataInfo: {},
      route: "",
      dataWork: {
        dayTotalSeconds: '',
        dayProgressSeconds: '',
        dayHours: "00:00"
      },
      myIntervals: {
        updateCurrentTime: null,
        updateProgressAndHoursWorking: null
      },
      workShiftType: 0,
      oneClick: false
    }
  },
  methods: {
    getWorkingLocalToday() {
      let date = moment(new Date()).format('YYYY-MM-DD');
      let url = WORKING_LOCAL_EMPLOYEE_TODAY + '?date=' + date


      UTIL_SERVICE.console("DATA SEND:", url);
      REQUEST_SERVICE.get(url).then((response) => {
        UTIL_SERVICE.console("RESULT WORKING_LOCAL_EMPLOYEE:", response.data);

        let value = 1

        if(response.data.workingLocal === 2) {
          value = 2
        }
        if(response.data.workingLocal === 3) {
          value = 3
        }

        this.addLocationPoint(value)

      }).catch(reason => {
        this.addLocationPoint(1)
      });
    },
    setTurnSelected(value) {
      this.turnSelected = value;
    },
    closeModal() {
      $('#modalWorkShift').modal('hide');
      this.turnSelected = ''
    },
    confirmPoint() {
      $('#modalWorkShift').modal('hide');
      if (this.turnSelected) {
        if (this.dateLastPoint) {
          if (this.dateLastPoint.lastDatePoint) {
            this.checkDateHoursFromLastPoint();
          } else {
            if (typeof this.dataInfo.userVacationType !== "undefined" && this.dataInfo.userVacationType !== 0) {
              this.showMessageHoliday();
            } else {
              this.sendPointNew();
            }
          }
        } else {
          if (typeof this.dataInfo.userVacationType !== "undefined" && this.dataInfo.userVacationType !== 0) {
            this.showMessageHoliday();
          } else {
            this.sendPointNew();
          }
        }
      }
    },
    refreshPage() {
      try {
        clearInterval(this.myIntervals.updateCurrentTime);
        clearInterval(this.myIntervals.updateProgressAndHoursWorking);
        this.stream.getTracks()[0].stop();
      } catch (e) {}

      setTimeout(()=>{
        window.location.reload();
      }, 400);
    },
    addLocationPoint(value) {
      if (!this.loadingRequest) {
        this.dataSendLocationPoint.local = value;
      }
    },
    sendLocationPoint() {
      if (this.dataSendLocationPoint.local > 0) {

        let obj = {
          userId: this.dataUserInfo.companyId,
          companyId: this.dataUserInfo.id,
          workingLocal: this.dataSendLocationPoint.local,
          date: moment(new Date()).format("YYYY-MM-DD"),
        }

        UTIL_SERVICE.console("DATA SEND:", obj);
        REQUEST_SERVICE.post(WORKING_LOCAL_EMPLOYEE, obj).then((response) => {
          UTIL_SERVICE.console("RESULT WORKING_LOCAL_EMPLOYEE:", response.data);

        }).catch(reason => {});
      }
    },
    addFeeling(value) {
      this.dataSendFeeling.mood = value;
    },
    sendFeelings() {
      if (this.dataSendFeeling.mood >= 0 && this.dataSendFeeling.mood !== '') {
        this.dataSendFeeling.deviceType = 3;
        this.dataSendFeeling.deviceId = JSON.parse(window.localStorage.getItem('browserId'));

        this.loadingSendFeeling = true;

        UTIL_SERVICE.console("DATA SEND:", this.dataSendFeeling);

        REQUEST_SERVICE.post(SEND_USER_FEELING, this.dataSendFeeling).then((response) => {
          UTIL_SERVICE.console("RESULT SEND_USER_FEELING:", response.data);

          window.localStorage.setItem('showFeelings', JSON.stringify({feelings: false}));
        }).catch(reason => {});
      }
    },
    captureCamImage() {
      // Capture Imagem from Webcam
      this.canvas = this.$refs.canvas;
      let context = this.canvas.getContext("2d").drawImage(this.video, 0, 0, 256, 256);
      this.captures = canvas.toDataURL("image/png");
      this.video.pause();
      this.video.src = "";
      this.stream.getTracks()[0].stop();

      $('#webCamModal').modal('toggle');
    },
    getCamImage() {
      // Get config to show video from webcam
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices.getUserMedia({video: true, audio: false}).then((stream) => {

          this.stream = stream;
          try {
            this.video.srcObject = stream;
          } catch (e) {
            this.video.src = window.URL.createObjectURL(stream);
          }
          this.video.play();
          this.haveCam = true;
        }).catch(err => {
          this.haveCam = false;
          //console.log("An error occurred -> " + err);
        });
      }
    },
    updateProgressAndHoursWorking() {
      this.dataWork.dayProgressSeconds += 60;
      let deg = (this.dataWork.dayProgressSeconds/this.dataWork.dayTotalSeconds * 100)/100 * 180;
      if (deg >= 180) deg = 180;
      document.getElementById("maskFull").style.transform = "rotate(" + deg + "deg)";
      document.getElementById("firstFill").style.transform = "rotate(" + deg + "deg)";
      document.getElementById("secondFill").style.transform = "rotate(" + deg + "deg)";

      let h = Math.floor(this.dataWork.dayProgressSeconds / 3600);
      if (h.toString().length === 1) h = "0" + h;
      let m = Math.floor(this.dataWork.dayProgressSeconds % 3600 / 60);
      if (m.toString().length === 1) m = "0" + m;

      this.dataWork.dayHours = h + ":" + m;
    },
    setProgressBar() {
      if (this.dataInfo.workedHours) {
        this.dataWork.dayHours = this.dataInfo.workedHours;
      } else {
        this.dataWork.dayHours = "00:00";
      }

      if (this.dataInfo.workedHours && this.dataInfo.workingDayTotal) {
        let whSeconds = this.dataInfo.workedHours; // your input string
        let a = whSeconds.split(':'); // split it at the colons
        this.dataWork.dayProgressSeconds = (+a[0]) * 60 * 60 + (+a[1]) * 60 + (+0); // minutes are worth 60 seconds. Hours are worth 60 minutes.

        let wdtSeconds = this.dataInfo.workingDayTotal;
        let b = wdtSeconds.split(':');
        this.dataWork.dayTotalSeconds = (+b[0]) * 60 * 60 + (+b[1]) * 60 + (+0);

        let deg = (this.dataWork.dayProgressSeconds/this.dataWork.dayTotalSeconds * 100)/100 * 180;
        if (deg >= 180) deg = 180;

        document.documentElement.style.setProperty('--transformEnd',deg + "deg");
        document.getElementById("maskFull").style.transform = "rotate(" + deg + "deg)";
        document.getElementById("firstFill").style.transform = "rotate(" + deg + "deg)";
        document.getElementById("secondFill").style.transform = "rotate(" + deg + "deg)";

        if (this.dataInfo.userPointDayStatus === 2) {
          this.myIntervals.updateProgressAndHoursWorking = setInterval(() => this.updateProgressAndHoursWorking(), 60000);
        }
      }
    },
    updateCurrentTime() {
      // Tick to clock
      this.timerBlockPage++;
      this.currentDateTime.setSeconds(this.currentDateTime.getSeconds() + 1);
      this.currentTime = moment(this.currentDateTime, "YYYYMMDD HH:mm").format('HH:mm:ss');

      if (this.timerBlockPage >= 120) {
        $('.modal').modal('hide');
        this.showBlockPage = true;
      }
    },
    getTimer() {
      // Get Timer from API
      this.loadingInfo = true;
      REQUEST_SERVICE.get(TIMER).then((response) => {
        UTIL_SERVICE.console("RESULT TIMER:", response.data);
        this.loadingInfo = false;
        this.currentDateTime = new Date(response.data);
        this.myIntervals.updateCurrentTime = setInterval(() => this.updateCurrentTime(), 900);

        setTimeout(()=>{
          this.setProgressBar();
        },200);

      }).catch(reason => {
        this.loadingInfo = false;
      });
    },
    pointInfo() {
      // Get info from point
      this.loadingInfo = true;
      this.loadingSendPoint = true;

      REQUEST_SERVICE.get(POINT_DAY_DETAIL).then((response) => {
        UTIL_SERVICE.console("RESULT POINT_DAY_DETAIL:", response.data);

        this.dataInfo = response.data;

        if (this.dataInfo.needLocationToModePointWeb) {
          const getDataLocation = new Promise(function (resolve, reject) {
            if (navigator.geolocation) {
              navigator.geolocation.getCurrentPosition(resolve, reject, {
                enableHighAccuracy: true,
                timeout: 60000,
                maximumAge: 0
              });
            } else {
              reject({doestSupport: true});
            }
          });
          getDataLocation.then((response) => {
            this.geoC.latitude = response.coords.latitude;
            this.geoC.longitude = response.coords.longitude;
            this.geoC.elevation = response.coords.altitude;
          });
        }
        this.getTimer();

        if (this.dataInfo.needPhotoToRegisterInWeb) {
          this.video = document.getElementById('video');
          // Get access to the camera!
          if(navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
            // Not adding `{ audio: true }` since we only want video now
            navigator.mediaDevices.getUserMedia({video: true})
              .then((stream) => {

                this.stream = stream;
                try {
                  video.srcObject = stream;
                } catch (e) {
                  video.src = window.URL.createObjectURL(stream);
                }
                video.play();
                this.haveCam = true;
              }).catch(err => {
              this.haveCam = false;
            });
          }
          //this.getCamImage();
        }
        this.loadingSendPoint = false;
      }).catch(reason => {
        this.currentDateTime = new Date();
        setInterval(() => this.updateCurrentTime(), 1000);

        this.loadingInfo = false;
        this.loadingSendPoint = false;
      });
    },
    checkPosition() {
      // Get current position
      return new Promise(function (resolve, reject) {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(resolve, reject, {
            enableHighAccuracy: true,
            timeout: 60000,
            maximumAge: 0
          });
        } else {
          reject({doestSupport: true});
        }
      });
    },
    showMessage5Minutes() {
      this.oneClick = false;

      swal({
        title: "Marcar o ponto novamente?",
        text: `Houve um registro há menos de 5 minutos (${moment(this.dateLastPoint.lastDatePoint).format('HH:mm')}).`, icon: "warning",
        buttons: ["Cancelar", "Sim, continuar"]
      }).then(continueResult => {
        if (continueResult) {
          if (typeof this.dataInfo.userVacationType !== "undefined" && this.dataInfo.userVacationType !== 0) {
            this.showMessageHoliday();
          } else {
            this.sendPointNew();
          }
        }
      });
    },
    showMessageHoliday() {
      this.oneClick = false;

      swal({
        title: "Atenção",
        text: `Você possui um afastamento hoje: (${this.dataInfo.userVacationTypeStr}).\n Tem certeza que deseja marcar seu ponto?`, icon: "warning",
        buttons: ["Cancelar", "Sim, continuar"]
      }).then(continueResult => {
        if (continueResult) {
          this.sendPointNew();
        }
      });
    },
    checkDateHoursFromLastPoint() {
      if (this.currentDateTime) {
        const lastPoint = new moment(new Date(this.dateLastPoint.lastDatePoint)).add(5, 'm').toDate();
        const currentDate = new Date(this.currentDateTime);

        if (currentDate.getTime() > lastPoint.getTime()) {
          if (typeof this.dataInfo.userVacationType !== "undefined" && this.dataInfo.userVacationType !== 0) {
            this.showMessageHoliday();
          } else {
            this.sendPointNew();
          }
        } else {
          this.showMessage5Minutes();
        }
      } else {
        const lastPoint = new moment(new Date(this.dateLastPoint.lastDatePoint)).add(5, 'm').toDate();
        const currentDate = new Date();

        if (currentDate.getTime() > lastPoint.getTime()) {
          if (typeof this.dataInfo.userVacationType !== "undefined" && this.dataInfo.userVacationType !== 0) {
            this.showMessageHoliday();
          } else {
            this.sendPointNew();
          }
        } else {
          this.showMessage5Minutes();
        }
      }
    },
    checkDataToRegisterPoint() {
      this.dataSendError = '';

      if(this.oneClick) {
        return
      } else {
        this.oneClick = true
      }

      if (this.workShiftType === 4) {
        return $('#modalWorkShift').modal();
      } else {
        if (this.dateLastPoint) {
          if (this.dateLastPoint.lastDatePoint) {
            this.checkDateHoursFromLastPoint();
          } else {
            if (typeof this.dataInfo.userVacationType !== "undefined" && this.dataInfo.userVacationType !== 0) {
              this.showMessageHoliday();
            } else {
              this.sendPointNew();
            }
          }
        } else {
          if (typeof this.dataInfo.userVacationType !== "undefined" && this.dataInfo.userVacationType !== 0) {
            this.showMessageHoliday();
          } else {
            this.sendPointNew();
          }
        }
      }
    },
    getListException() {
      REQUEST_SERVICE.get(GET_EXCEPTION).then((response) => {
        UTIL_SERVICE.console("RESULT GET_EXCEPTION:", response.data);

        this.listException = response.data;

      });
    },
    cancelMainLoading() {
      this.loadingSendPoint = false;
    },
    sendPointNew() {
      if (this.loadingRequest === false) {
        this.loadingRequest = true;
        this.dataSendError = '';

        try {
          this.historyListPoints = UTIL_SERVICE.getStorage('historyListPoints');
          this.historyListPoints.hasNotification = true;

          if (this.historyListPoints.list.length >= 10)
            this.historyListPoints.list.splice(this.historyListPoints.list.length - 1, 1);
        } catch (err) {
          console.log(err.message);
        }

        try {
          this.homeCtrl = UTIL_SERVICE.getStorage('homeCtrl');
          this.homeCtrl.resetPoints = true;
        } catch(err) {
          //console.log(err.message);
        }

        const exemploJson = {
          fromWhere: "",
          geoC: {},
          device: {
            id: '',
            model: '',
            appVersion: '',
            type: ''
          },
          image: {},
          aditionalInfo: {
            contextCode: '',
            online: true
          },
          userId: '',
          companyId: '',
          date: ''
        };

        if (this.workShiftType === 4) {
          exemploJson.aditionalInfo.pointRegisterType = this.turnSelected;
        }

        if (this.needGadgets) {
          if (this.selectedGadgets) {
            exemploJson.aditionalInfo.locationId = this.selectedGadgets.id;
          } else {
            if (this.listGadgets.length) {
              this.loadingRequest = false;
              this.dataSendError = 'Selecione o local que você está para marcar seu ponto.';
              this.oneClick = false
              return '';
            }
          }
        }

        if (this.needException) {
          if (this.selectedException) {
            exemploJson.sporadicCategoryId = this.selectedException.id;
          } else {
            if (this.listException.length) {
              this.loadingRequest = false;
              this.dataSendError = 'Selecione o motivo do ponto por exceção para marcar seu ponto.';
              this.oneClick = false
              return '';
            }
          }
        }

        if (this.dataInfo.needLocationToModePointWeb) {
          if (this.geoC.latitude || this.geoC.longitude) {
            exemploJson.geoC.latitude = this.geoC.latitude;
            exemploJson.geoC.longitude = this.geoC.longitude;
            exemploJson.geoC.elevation = this.geoC.altitude;
          } else {
            const dataLocation = new Promise(function (resolve, reject) {
              if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(resolve, reject, {
                  enableHighAccuracy: true,
                  timeout: 60000,
                  maximumAge: 0
                });
              } else {
                reject({doestSupport: true});
              }
            });

            dataLocation.then((response) => {
              exemploJson.geoC.latitude = response.coords.latitude;
              exemploJson.geoC.longitude = response.coords.longitude;
              exemploJson.geoC.elevation = response.coords.altitude;
            }).catch(reason => {
              this.loadingRequest = false;

              delete this.dataRegister.baseImage;
              UTIL_SERVICE.historyLog(false, window.location.pathname, 'checkPosition', this.dataRegister, true, reason);

              if (reason.doestSupport) {
                $("#modalDontSupport").modal();

                try {
                  let browserInfo = UTIL_SERVICE.checkBrowser();
                  let objSend = {};
                  objSend.text = `Browser not support location, open modal alert update browser.`;
                  objSend.subject = "99";
                  objSend.userId = JSON.parse(window.localStorage.getItem('userInfo')).id;
                  objSend.deviceModel = browserInfo.name;
                  objSend.version = browserInfo.version;
                  objSend.deviceType = "3";
                  REQUEST_SERVICE.post(SEND_BUG, objSend).then((response) => {
                    UTIL_SERVICE.console("RESULT :", response.data);
                  });
                } catch (e) {}
              } else {
                // $("#myModal").modal();

                try {
                  let browserInfo = UTIL_SERVICE.checkBrowser();
                  let objSend = {};
                  objSend.text = `COD: ${reason.code}, MESSAGE: ${reason.message}, PERMISSION_DENIED: ${reason.PERMISSION_DENIED}, POSITION_UNAVAILABLE: ${reason.POSITION_UNAVAILABLE}, TIMEOUT: ${reason.TIMEOUT}`;
                  objSend.subject = "99";
                  objSend.userId = JSON.parse(window.localStorage.getItem('userInfo')).id;
                  objSend.deviceModel = browserInfo.name;
                  objSend.version = browserInfo.version;
                  objSend.deviceType = "3";
                  REQUEST_SERVICE.post(SEND_BUG, objSend).then((response) => {
                    UTIL_SERVICE.console("RESULT :", response.data);
                  });
                } catch (e) {}

                switch (reason.code) {
                  case 1:
                    // swal("Aviso", "Usuário rejeitou a solicitação de Geolocalização.", "error");
                    break;
                  default:

                    break;
                }
              }
            });
          }
        }

        setTimeout(() => {
          // Get Browser Info
          try {
            let browserInfo = UTIL_SERVICE.checkBrowser();
            exemploJson.device.model = browserInfo.name;
            exemploJson.device.appVersion = browserInfo.version;
          } catch (err) {
            //console.log(err.message);
          }

          // Get web cam image.
          try {
            if (this.dataInfo.needPhotoToRegisterInWeb && this.haveCam) {
              this.canvas = this.$refs.canvas;
              let context = this.canvas.getContext("2d").drawImage(video, 0, 0, 640, 480);
              this.captures = canvas.toDataURL("image/png");
              exemploJson.image.imageBase64 = this.captures;
            }
          } catch (err) {
            //console.log(err.message);
          }

          if (this.currentDateTime) {
            exemploJson.date = moment(this.currentDateTime, "YYYYMMDD HH:mm").format();
          } else {
            exemploJson.date = moment(new Date(), "YYYYMMDD HH:mm").format();
          }

          exemploJson.device.type = "3";
          exemploJson.fromWhere = 'Web';
          exemploJson.aditionalInfo.online = true;
          exemploJson.userId = this.dataUserInfo.id;
          exemploJson.companyId = this.dataUserInfo.companyId;
          exemploJson.aditionalInfo.contextCode = this.dataAuthInfo.userContentSetting;
          exemploJson.device.id = UTIL_SERVICE.getStorage('browserId');

          let url = NEW_REGISTER_POINT;

          UTIL_SERVICE.console("DATA SEND:", exemploJson);
          REQUEST_SERVICE.post(url, exemploJson).then((response) => {
            UTIL_SERVICE.console("RESULT REGISTER_POINT registerWithLocation:", response.data);
            if (response.data.succeed) {
              try {
                
                const dataConfigProgressPoint = UTIL_SERVICE.getStorage('configProgressPoint');

                if (dataConfigProgressPoint.fromDay !== moment(new Date()).format('DD/MM/YYYY')) {
                  UTIL_SERVICE.saveStorage('configProgressPoint',{
                    totalPoint: 1,
                    newPointRegister: 0,
                    fromDay: moment(new Date()).format('DD/MM/YYYY')
                  });
                } else {
                  let totalPoint = dataConfigProgressPoint.totalPoint + 1;
                  UTIL_SERVICE.saveStorage('configProgressPoint',{
                    totalPoint: dataConfigProgressPoint.totalPoint,
                    newPointRegister: totalPoint,
                    fromDay: moment(new Date()).format('DD/MM/YYYY')
                  });
                }
              } catch (e) {}

              if (this.showFeelingsDay) {
                this.sendFeelings();
              }

              this.loadingRequest = false;

              try {
                clearInterval(this.myIntervals.updateCurrentTime);
                clearInterval(this.myIntervals.updateProgressAndHoursWorking);
                this.stream.getTracks()[0].stop();
              } catch (e) {}

              // Reset storage history
              this.historyListPoints.list.unshift({text: 'Ponto registrado as: ', date: response.data.finishedAt, type: 1});
              UTIL_SERVICE.saveStorage('historyListPoints', this.historyListPoints);
              UTIL_SERVICE.saveStorage('homeCtrl', this.homeCtrl);
              UTIL_SERVICE.saveStorage('pointHistoryCtrl', {
                getRequest: true,
                controlBy4Hours: null,
                dateAtt: null,
                initDate: null,
                endDate: null,
                listHistory: []
              });

              try { UTIL_SERVICE.saveStorage('dateLastPointConfirm', {lastDatePoint: response.data.finishedAt, showCache: true}); } catch (e) {}

              // $("#successRegisterPoint").modal();
              try {
                response.data.date = response.data.finishedAt;
              } catch (e) {}

              UTIL_SERVICE.saveStorage('dataConfirmPoint', {dataConfirm: response.data});
              try { UTIL_SERVICE.saveStorage('dataDateLastPoint', {date: response.data.finishedAt}); } catch (e) {}

              delete this.dataRegister.baseImage;
              UTIL_SERVICE.historyLog(false, window.location.pathname, 'registerWithLocation', this.dataRegister, false);

              try {
                if(this.dataInfo.useWorkingLocalUser) {
                  this.sendLocationPoint();
                }
              } catch (e) {}

              this.$router.push({path: '/confirmacao-de-ponto'});
              this.oneClick = false;
            } else {
              this.loadingRequest = false;
              this.oneClick = false;

              delete this.dataRegister.baseImage;
              UTIL_SERVICE.historyLog(false, window.location.pathname, 'registerWithLocation', this.dataRegister, true, response.data);

              console.log('a', response.data.results.permissions.errors[0])

              // Show errors.
              let msgError = null;
              response.data.errors.map((value, index) => {

                if (msgError) {
                  msgError += `, ${value}`;
                } else {
                  msgError = value;
                }

                if (response.data.errors.length === index + 1) {
                  swal("Aviso", msgError, "error");
                }
              });

              if(response.data.results.permissions.errors.length) {
                swal("Aviso", response.data.results.permissions.errors[0], "error");
              }
            }

            this.oneClick = false;
          }).catch(reason => {
            this.loadingRequest = false;

            delete this.dataRegister.baseImage;
            UTIL_SERVICE.historyLog(false, window.location.pathname, 'registerWithLocation', this.dataRegister, true);
          });
        }, 2000);
      }
    }
  },
  beforeMount() {
    const progressPoint = UTIL_SERVICE.getStorage('configProgressPoint');

    try {
      if (progressPoint.fromDay !== moment(new Date()).format('DD/MM/YYYY')) {
      UTIL_SERVICE.saveStorage('configProgressPoint',{
        totalPoint: 0,
        newPointRegister: 0,
        fromDay: moment(new Date()).format('DD/MM/YYYY')
      });
    }
    } catch (error) {
      console.error(error)
    }
    try {
      this.dataAuthInfo = UTIL_SERVICE.getStorage('authUser');
      this.dataUserInfo = UTIL_SERVICE.getStorage('userInfo');
    } catch (e) {}
    try {
      const dateLastPoint = UTIL_SERVICE.getStorage('dataDateLastPoint');
      if (dateLastPoint) {
        this.dateLastPoint.dateLastPoint = dateLastPoint.date;
      } else {
        this.dateLastPoint = UTIL_SERVICE.getStorage('dateLastPointConfirm');
      }
    } catch (e) {
      this.dateLastPoint = UTIL_SERVICE.getStorage('dateLastPointConfirm');
    }

    try {
      let chooseTheme = JSON.parse(window.localStorage.getItem('darkMode'));
      if (chooseTheme) {
        this.isDark = JSON.parse(window.localStorage.getItem('darkMode')).dark;
      }
    } catch (e) {}

    // Remove storage
    window.localStorage.removeItem("dataConfirmPoint");

    // Check show feelings
    let dataFeeling = UTIL_SERVICE.getStorage('showFeelings');
    if (dataFeeling) this.showFeelingsDay = dataFeeling.feelings;

    if (JSON.parse(window.localStorage.getItem('userInfo')).company.id === '2C25B65430F649E0BAD4A55C67B3FD7C')
      this.showFeelingsDay = false;

    // Check Pause
    this.showPause = JSON.parse(window.localStorage.getItem('userInfo')).company.isUsingPause;

    try {
      this.workShiftType = this.dataUserInfo.workShift.workShiftType;
    } catch (e) {}

    moment.locale('pt-br');

    this.pointInfo();
    this.getListException()

    let dataConfigMenu = UTIL_SERVICE.getStorage('configMenu');
    let dataUserInfo = UTIL_SERVICE.getStorage('userInfo');

    try {
      if (dataUserInfo.company) {
        if (dataUserInfo.company.hasLocation) {
          this.needGadgets = true;
          this.listGadgets = [];
          this.listGadgets = dataUserInfo.company.locations;
        }
      }

      if(dataUserInfo.company.sporadic) {
        this.needException = dataUserInfo.company.sporadic
      }
    } catch (e) {}

    try {
      if (dataConfigMenu) {
        if (dataConfigMenu.hasLocation) {
          this.needGadgets = true;
          this.listGadgets = [];
          this.listGadgets = dataConfigMenu.locations;
        }
      }
    } catch (e) {}

    this.getWorkingLocalToday();

    setInterval(() => this.cancelMainLoading(), 12000)
  },
  watch: {
    route: function (value) {
      this.$router.push({path: '/'});
    }
  }
}
</script>

<style lang="scss">

.box-register-point {
  min-height: 466.61px !important;
}

.empty-content {
  .img-responsive {
    width: 45% !important;
  }
}

.content-answer-location {
  margin-top: 25px;
  .set-location-point {
    display: flex;
    justify-content: center;
    flex-direction: row;
    flex-wrap: wrap;
    margin-top: 30px;
    cursor: pointer;
    padding: 0 10px;

    .locations-point {
      padding: 5px 10px;
      min-width: 100px;
      max-width: 100px;
      color: var(--linkColor);
      transition: .2s;
      border: 1px solid var(--bodyColor);

      &:hover {
        -webkit-filter: opacity(100%);
        filter: opacity(100%);
      }

      span {
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 13px;
        font-weight: 700;

        ion-icon {
          font-size: 30px;
          margin-bottom: 5px;
          margin-top: 3px;
        }
      }

      @media only screen and (max-width: 767px) {
        margin-top: 0 !important;
      }

      &:hover {
        background: var(--linkColor);
        color: #ffffff;
      }
    }

    .locations-point-1 {
      border-top-left-radius: 12px;
      border-bottom-left-radius: 12px;
      border-right: 1px solid var(--bodyColor);
    }

    .locations-point-3 {
      border-top-right-radius: 12px;
      border-bottom-right-radius: 12px;
      border-left: 1px solid var(--bodyColor);
    }

    @media only screen and (max-width: 1127px) {

      .locations-point-2 {
        border-top-right-radius: 12px;
        border-bottom-right-radius: 12px;
      }

      .locations-point-3 {
        border-top-right-radius: 0;
        border-bottom-left-radius: 12px;
        border-bottom-right-radius: 12px;
      }
    }

    @media only screen and (max-width: 991px) {
      .locations-point-1 {
        border-top-right-radius: 12px;
        border-top-left-radius: 12px;
        border-bottom-left-radius: 0;
      }

      .locations-point-2 {
        border-radius: 0;
      }

      .locations-point-3 {
        border-top-right-radius: 0;
        border-bottom-left-radius: 12px;
        border-bottom-right-radius: 12px;
      }
    }

    @media only screen and (max-width: 767px) {
      .locations-point-1 {
        border-top-left-radius: 12px;
        border-bottom-left-radius: 12px;
        border-top-right-radius: 0;
      }

      .locations-point-2 {
        border-radius: 0;
      }

      .locations-point-3 {
        border-top-right-radius: 12px;
        border-bottom-right-radius: 12px;
        border-bottom-left-radius: 0;
      }
    }
  }
}

.box-info-hours {
  .hours-info {
    margin: 6.5% 0 !important;
  }
}

#modalWorkShift {
  .modal-dialog {
    max-width: 426px;

    @media only screen and (max-width: 520px) {
      max-width: 96%;
      min-width: 96%;
    }
  }

  .modal-workshift {
    padding: 30px;
    box-shadow: none;
    border: none;
    border-radius: 8px;

    .modal-header {
      padding: 0 0 10px 0;
      border-bottom: 1px solid var(--bodyColor);

      .close {
        top: 10px;
        right: 10px;
      }

      span {
        color: var(--titleBox);
        font-size: 24px;
        font-weight: 700;
        line-height: 31.2px;
      }
    }

    .modal-body {
      padding: 0;

      .body-content {
        border-bottom: 1px solid var(--bodyColor);

        .content-btn {
          position: relative;
          border-radius: 4px;
          width: 100%;
          margin-bottom: 15px;
          cursor: pointer;
          transition: .2s;

          &:first-child {
            margin-top: 24px;
          }

          .last-point {
            position: absolute;
            top: -10px;
            left: 8px;
            background-color: var(--linkColor);
            color: #FFFFFF;
            padding: 3px 12px;
            font-size: 10px;
            font-weight: 700;
            line-height: 14.06px;
            border-radius: 30px;
          }

          .btn-text {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 12px 0;

            font-size: 14px;
            font-weight: 400;
            line-height: 19.69px;
            color: var(--textSide);

            svg {
              margin-right: 4px;
            }
          }

          .last-appointment {
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            position: absolute;
            right: 16px;
            top: 7px;
            color: var(--textSide);

            .last-day {
              font-size: 10px;
              font-weight: 400;
              line-height: 14.06px;
            }

            .last-hour {
              font-weight: 400;
              font-size: 14px;
              line-height: 14px;
            }
          }
        }

        .point-entrance {
          border: 1px solid #2ACC6B;

          &:hover {
            background-color: rgba(42, 204, 107, 0.15);
          }

          &:focus, &:focus-within, &:active {
            background-color: #2ACC6B;

            .btn-text {
              color: #FFFFFF;

              svg {
                path {
                  fill: #FFFFFF;
                }
              }
            }

            .last-appointment {
              color: #FFFFFF;
            }
          }
        }

        .point-exit-interval {
          border: 1px solid #FF9900;

          &:hover {
            background-color: rgba(255, 153, 0, 0.15);
          }

          &:focus, &:focus-within, &:active {
            background-color: #FF9900;

            .btn-text {
              color: #FFFFFF;

              svg {
                path {
                  fill: #FFFFFF;
                }
              }
            }

            .last-appointment {
              color: #FFFFFF;
            }
          }
        }

        .btn-back-interval {
          border: 1px solid #2F23D6;

          &:hover {
            background-color: rgba(47, 35, 214, 0.15);
          }

          &:focus, &:focus-within, &:active {
            background-color: #2F23D6;

            .btn-text {
              color: #FFFFFF;

              svg {
                path {
                  fill: #FFFFFF;
                }
              }
            }

            .last-appointment {
              color: #FFFFFF;
            }
          }
        }

        .point-exit {
          border: 1px solid #FF445D;

          &:hover {
            background-color: rgba(255, 68, 93, 0.15);
          }

          &:focus, &:focus-within, &:active {
            background-color: #FF445D;

            .btn-text {
              color: #FFFFFF;

              svg {
                path {
                  fill: #FFFFFF;
                }
              }
            }

            .last-appointment {
              color: #FFFFFF;
            }
          }
        }
      }

      .footer-content {

        .point-repeat {
          text-align: center;
          margin-top: 8px;
          font-size: 14px;
          font-weight: 400;
          line-height: 19.69px;
          color: #FF445D;
        }

        .content-btn {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          margin-top: 16px;

          .btn-cancel {
            padding: 11px 31px;
            color: #FFFFFF;
            background: var(--defaultText);
            border-radius: 4px;
            transition: .2s;
            cursor: pointer;
            margin-right: 16px;

            &:hover {
              color: #FFFFFF;
              background: #6b7380;
            }
          }

          .btn-confirm {
            border: none;
            display: flex;
            align-items: center;
            background: var(--linkColor);
            color: #FFFFFF;
            padding: 11px 15px;
            border-radius: 4px;
            transition: .2s;
            cursor: pointer;

            svg {
              margin-right: 4px;

              @media only screen and (max-width: 380px) {
                display: none;
              }
            }

            &:hover {
              background: #2c2588;
            }

            &:disabled {
              cursor: no-drop;
              color: var(--bodyContrast);
              background: var(--defaultText);
              filter: grayscale(.5);
            }
          }
        }
      }
    }
  }

}

.block-page {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 30;

  .bg-color {
    background: #191919;
    opacity: 0.45;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
  }

  .info-block {
    text-align: center;
    background: var(--bodyColor);
    width: 500px;
    height: 250px;
    padding: 20px 14px 14px;
    border-radius: 4px;
    position: absolute;
    z-index: 10;
    top: -200px;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;

    h4 {
      font-family: 'Montserrat', sans-serif;
      font-style: normal;
      font-weight: 700;
      font-size: 21px;
      text-align: center;
      color: var(--titleBox);
    }

    p {
      font-family: 'Montserrat', sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 130%;
      text-align: center;
      padding-bottom: 20px;
      border-bottom: 1px solid var(--line);
      color: var(--titleBox);
    }

    button {
      width: 90%;
      height: 42px;
      left: 30px;
      top: 267px;
      font-family: 'Montserrat', sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      border: none;
      color: #FFFFFF;
      background: var(--textActiveSide);
      border-radius: 4px;
      margin: 20px auto 0;
    }
  }

}

.content-gadgets {
  width: 80%;
  display: block;
  margin: 0 auto;

  p {
    color: var(--defaultText);
  }
}

.field-10 {
  margin: 10px 0;
}

.btn-point {
  background: var(--linkColor) !important;
  margin-bottom: 10px !important;
}

</style>



// WEBPACK FOOTER //
// src/vue/views/restricted/point/Point.vue